var chunkMapping = {
	"src_bootstrap_tsx-src_bootstrapNoauth_tsx": [
		"webpack/container/remote/accounts/exports",
		"webpack/container/remote/notification/exports",
		"webpack/container/remote/dashboards/exports",
		"webpack/container/remote/reports/exports",
		"webpack/container/remote/campaigns/exports",
		"webpack/container/remote/billing/exports",
		"webpack/container/remote/customdomains/exports",
		"webpack/container/remote/entities/exports",
		"webpack/container/remote/topbar/exports",
		"webpack/container/remote/mailinglists/exports",
		"webpack/container/remote/maindash/exports",
		"webpack/container/remote/core/util",
		"webpack/container/remote/core/history",
		"webpack/container/remote/core/config",
		"webpack/container/remote/core/services",
		"webpack/container/remote/notification/Notification",
		"webpack/container/remote/topbar/Topbar"
	],
	"webpack_container_remote_standalone_Standalone": [
		"webpack/container/remote/standalone/Standalone"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/accounts/exports": [
		"default",
		"./exports",
		"webpack/container/reference/accounts"
	],
	"webpack/container/remote/notification/exports": [
		"default",
		"./exports",
		"webpack/container/reference/notification"
	],
	"webpack/container/remote/dashboards/exports": [
		"default",
		"./exports",
		"webpack/container/reference/dashboards"
	],
	"webpack/container/remote/reports/exports": [
		"default",
		"./exports",
		"webpack/container/reference/reports"
	],
	"webpack/container/remote/campaigns/exports": [
		"default",
		"./exports",
		"webpack/container/reference/campaigns"
	],
	"webpack/container/remote/billing/exports": [
		"default",
		"./exports",
		"webpack/container/reference/billing"
	],
	"webpack/container/remote/customdomains/exports": [
		"default",
		"./exports",
		"webpack/container/reference/customdomains"
	],
	"webpack/container/remote/entities/exports": [
		"default",
		"./exports",
		"webpack/container/reference/entities"
	],
	"webpack/container/remote/topbar/exports": [
		"default",
		"./exports",
		"webpack/container/reference/topbar"
	],
	"webpack/container/remote/mailinglists/exports": [
		"default",
		"./exports",
		"webpack/container/reference/mailinglists"
	],
	"webpack/container/remote/maindash/exports": [
		"default",
		"./exports",
		"webpack/container/reference/maindash"
	],
	"webpack/container/remote/core/util": [
		"default",
		"./util",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/core/history": [
		"default",
		"./history",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/core/config": [
		"default",
		"./config",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/core/services": [
		"default",
		"./services",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/notification/Notification": [
		"default",
		"./Notification",
		"webpack/container/reference/notification"
	],
	"webpack/container/remote/topbar/Topbar": [
		"default",
		"./Topbar",
		"webpack/container/reference/topbar"
	],
	"webpack/container/remote/standalone/Standalone": [
		"default",
		"./Standalone",
		"webpack/container/reference/standalone"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}